export default externalUrlMiddleware()
